import assetPath from '/app/xinglets/lebenslauf/components/frame/src/assets/anschreiben-logo-light.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')